<template>
    <a :href="route('shopping-cart')" _target="blank" class="btn header__cart-btn custom-btn">
        <span class="login-btn__icon icon-Cart">
            <span class="cart-badge" v-if="totals.quantity > 0">{{totals.quantity}}</span>
        </span>
    </a>
</template>

<script setup>

</script>
<script>
import {CartMixin} from "./CartMixin";

export default {
    name: "HeaderCart",
    mixins: [CartMixin],
}
</script>

<style scoped>

</style>
